import React, { useEffect, useState } from "react";
// import background from "../../assets/background.png";
import AuthBanner from "../../assets/auth_signup.png";
import {
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Spinner,
  Container,
  Breadcrumb,
  BreadcrumbItem,
} from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import eyeshow from "../../assets/eyeshow.svg";
import eyehide from "../../assets/eyehide.svg";
import { signUp } from "../../services/auth.service";
import { authSignUp } from "../../Shared/validation";
import "react-toastify/dist/ReactToastify.css";
import { GoHome } from "react-icons/go";
import { MdOutlineNavigateNext } from "react-icons/md";
import Footer from "../../layout/Footer";

function SignUp() {
  const [passwordType, setPasswordType] = useState("password");
  const [checked, setChecked] = useState(false);
  const [errCheck, setErrCheck] = useState("");
  const [errors, setErrors] = useState({});
  const [LoginClick, setLoginClick] = useState(false);
  const [values, setValues] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
  });

  const navigate = useNavigate();

  useEffect(() => {
    setTimeout(() => {
      window?.scrollTo({ top: 0, behavior: "smooth" });
    }, 0);
  }, []);

  const togglePassword = () => {
    if (passwordType === "password") {
      setPasswordType("text");
      return;
    }
    setPasswordType("password");
  };

  const clickCheck = () => {
    if (checked === false) {
      setErrCheck("");
    } else {
      setErrCheck(
        "Kindly check the Terms of Service and Privacy Policy checkbox"
      );
    }
    setChecked(!checked);
  };

  var regex =
    /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g;

  const handleChange = (e) => {
    const newData = { ...values };
    newData[e?.target?.id] = e?.target?.value
      ?.replace(/^\s+/, "")
      ?.replace(regex, "");
    if (errors !== null) {
      errors[e?.target?.id] = null;
    }
    setValues(newData);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // validattion

    if (values?.firstName?.replace(/\s*$/, "") === "") {
      setErrors({ firstName: "First Name is required" });
      return;
    }
    if (values?.lastName?.replace(/\s*$/, "") === "") {
      setErrors({ lastName: "Last Name is required" });
      return;
    }
    if (values?.email?.replace(/\s*$/, "") === "") {
      setErrors({ email: "Email is required" });
      return;
    }
    if (values?.password?.replace(/\s*$/, "") === "") {
      setErrors({ password: "Password is required" });
      return;
    }

    // validation email
    const email = values?.email?.replace(/\s*$/, "");
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    if (emailRegex.test(email) === false) {
      setErrors({ email: "Email is not valid" });
      return;
    }

    // validation password
    // validation password
    const password = values?.password?.replace(/\s*$/, "");
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/;
    if (passwordRegex.test(password) === false) {
      setErrors({
        password:
          "Password must contain at least 8 characters, 1 uppercase, 1 lowercase, and 1 number",
      });
      return;
    }

    const errors = await authSignUp(values);
    setErrors(errors);
    if (checked === false) {
      setErrCheck(
        "Kindly check the Terms of Service and Privacy Policy checkbox"
      );
      setLoginClick(false);
    } else {
      setErrCheck("");
    }

    if (errors === null && checked === true) {
      setErrors({});
      setLoginClick(true);
      try {
        const response = await signUp({
          firstName: values?.firstName?.replace(/\s*$/, ""),
          lastName: values?.lastName?.replace(/\s*$/, ""),
          email: values?.email?.replace(/\s*$/, ""),
          password: values?.password?.replace(/\s*$/, ""),
        });
        if (response && response?.status === 200) {
          setValues(response?.data);
          return (
            toast.success("Sign Up Successful!", {
              position: toast.POSITION.TOP_RIGHT,
            }),
            setTimeout(() => {
              navigate("/sign-in");
            }, 2000)
          );
        } else {
          toast.error("Email ID is already registered", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2000,
          });
          setLoginClick(false);
        }
      } catch (err) {
        let error_message = "Email ID is already registered";
        if (
          err?.response &&
          err?.response?.data &&
          err?.response?.data?.message
        ) {
          error_message = err?.response?.data?.message;
        }
        toast.error(error_message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        });
        setLoginClick(false);
      }
    }
  };

  const isDiasabled = () => {
    if (LoginClick === true) {
      return true;
    }
  };

  return (
    <section>
      <Container>
        <Breadcrumb className="nt-breadcrumb">
          <Link to="/" className="breadcrumb_item1">
            <GoHome className="home_icon" />
          </Link>
          <span className="breadcrumb-divider">
            <MdOutlineNavigateNext />
          </span>
          <BreadcrumbItem active>
            <Link to="/sign-in" className="nt-breadcrumb_item2">
              Sign Up
            </Link>
          </BreadcrumbItem>
        </Breadcrumb>
        <div className="signin_section">
          <div className="signin_container">
            <div className="Leftsection">
              <img src={AuthBanner} alt="loading" />
            </div>
            <div className="Rightsection">
              <Form onSubmit={handleSubmit} className="signinform">
                <h3>Create an Account</h3>
                <p>
                  Start your spirtual journey with Nesiya Tova. Create your
                  account.
                </p>
                <div className="form_section">
                  <FormGroup>
                    <Label>First Name*</Label>
                    <Input
                      id="firstName"
                      name="firstName"
                      autoComplete="off"
                      value={values?.firstName}
                      onChange={handleChange}
                      placeholder="First Name"
                      type="text"
                      maxLength="30"
                    />
                    <span className="error">
                      {errors?.firstName && errors?.firstName}
                    </span>
                  </FormGroup>
                  <FormGroup>
                    <Label>Last Name*</Label>
                    <Input
                      id="lastName"
                      name="lastName"
                      autoComplete="off"
                      value={values?.lastName}
                      onChange={handleChange}
                      placeholder="Last Name"
                      type="text"
                      maxLength="30"
                    />
                    <span className="error">
                      {errors?.lastName && errors?.lastName}
                    </span>
                  </FormGroup>
                  <FormGroup>
                    <Label>Email*</Label>
                    <Input
                      id="email"
                      name="email"
                      autoComplete="off"
                      value={values?.email}
                      onChange={handleChange}
                      placeholder="Email ID"
                      autoCapitalize="none"
                      type="text"
                    />
                    <span className="error">
                      {errors?.email && errors?.email}
                    </span>
                  </FormGroup>
                  <FormGroup>
                    <div className="password">
                      <Label>Password*</Label>
                      <Input
                        id="password"
                        name="password"
                        autoComplete="off"
                        value={values?.password}
                        onChange={handleChange}
                        placeholder="Password"
                        type={passwordType}
                      />
                      <Link to="#" onClick={togglePassword}>
                        {passwordType === "password" ? (
                          <img
                            src={eyeshow}
                            alt="show"
                            style={{ marginTop: "31px" }}
                          />
                        ) : (
                          <img
                            src={eyehide}
                            alt="hide"
                            style={{ marginTop: "31px" }}
                          />
                        )}
                      </Link>
                    </div>
                    <span className="error">
                      {errors?.password && errors?.password}
                    </span>
                  </FormGroup>
                  <FormGroup check>
                    <Input
                      type="checkbox"
                      id="checked"
                      name="checked"
                      onClick={clickCheck}
                    />{" "}
                    <Label check className="check_box">
                      I agree to the{" "}
                      <Link to="#" style={{ color: "blue" }}>
                        Terms of Service
                      </Link>{" "}
                      and{" "}
                      <Link to="#" style={{ color: "blue" }}>
                        Privacy Policy
                      </Link>
                    </Label>
                    <br />
                    <span className="error">{errCheck}</span>
                  </FormGroup>
                  <Button type="submit" disabled={isDiasabled()}>
                    {LoginClick === true ? (
                      <Spinner size="sm"></Spinner>
                    ) : (
                      "Create Account"
                    )}
                  </Button>
                  <div className="no_account">
                    <Label className="noaccount">
                      Already existing account?
                    </Label>
                    <Link to="/sign-in" className="signup">
                      Sign In
                    </Link>
                  </div>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </Container>
      <Footer />
    </section>
  );
}

export default SignUp;
